import React from 'react';

const Footer = () => {
  return (
    <footer className='footer'>
      <p>&copy; Z-Works. All rights reserved.</p>
    </footer>
  );
};


export default Footer;